// src/redux/Actions/studentPlacementAnswerActions.js
import {
  STUDENT_SET_MCQ_SELECTION,
  STUDENT_SET_LESEN_SELECTION,
  STUDENT_SET_AUDIO_SELECTION,
  STUDENT_SET_SCHREIBEN_TEXT,
  STUDENT_AUDIO_PLAY_INCREMENT,
  STUDENT_AUDIO_BLOCK,
  STUDENT_ANSWERS_RESET,
} from "./types";

export const setMcqSelection    = (qid, index, text) => ({ type: STUDENT_SET_MCQ_SELECTION, payload: { qid, index, text } });
export const setLesenSelection  = (qid, index, text) => ({ type: STUDENT_SET_LESEN_SELECTION, payload: { qid, index, text } });
export const setAudioSelection  = (qid, index, text) => ({ type: STUDENT_SET_AUDIO_SELECTION, payload: { qid, index, text } });

export const setSchreibenText   = (text) => ({ type: STUDENT_SET_SCHREIBEN_TEXT, payload: text });

export const audioPlayIncrement = () => ({ type: STUDENT_AUDIO_PLAY_INCREMENT });
export const audioBlock         = () => ({ type: STUDENT_AUDIO_BLOCK });

export const resetStudentAnswers = () => ({ type: STUDENT_ANSWERS_RESET });
